module.exports = __webpack_public_path__ + "img/infoIcon.c9a7bcd9.svg";